import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useContentStyles } from './styles';
import Routes from '../../views/Routes';
import BreadCrumbs from '../../common/BreadCrumbs';

const Content = ({ ...props }) => {
  const { mobile } = props;

  const classes = useContentStyles({ mobile });
  return (
    <React.Fragment>
      <Box
        display="flex"
        justifyContent="center"
        maxWidth="1400px"
        margin="0 auto"
        className={classes.container}
      >
        <Box
          marginTop={mobile ? '25px' : '50px'}
          marginBottom={mobile ? '25px' : '50px'}
          maxWidth="795px"
          className={classes.innerContainer}
        >
          <Box marginLeft={mobile ? '10px' : ''}>
            <BreadCrumbs mobile />
          </Box>
          <Routes mobile={mobile} />
        </Box>
      </Box>
    </React.Fragment>
  );
};

Content.propTypes = {
  mobile: PropTypes.bool,
};

export default Content;
